export default "__VITE_ASSET__766698ee__"